import Box from '@mui/material/Box';
import { FC } from 'react';

const BRAND = '#ff4d6d';

interface AnswerCheckmarkProps {
  isSelected: boolean;
}

/**
 * The box beside a quiz answer. A selected answer always shows a checkmark —
 * the same mark for single-choice, true/false and multi-select — so "this is my
 * answer" reads the same on every question type.
 */
export const AnswerCheckmark: FC<AnswerCheckmarkProps> = ({ isSelected }) => (
  <Box
    aria-hidden
    sx={{
      width: 20,
      height: 20,
      border: '2px solid',
      borderColor: isSelected ? BRAND : '#ccc',
      borderRadius: '4px',
      bgcolor: isSelected ? BRAND : 'white',
      color: 'white',
      flexShrink: 0,
      mt: 0.25,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background-color 0.15s, border-color 0.15s',
    }}
  >
    {isSelected && (
      // The bold text tick multi-select always used — kept over an icon glyph
      // because it reads heavier and rounder in the small box.
      <Box component="span" sx={{ fontSize: 14, fontWeight: 'bold', lineHeight: 1 }}>
        ✓
      </Box>
    )}
  </Box>
);
